/* Style Mobo — Cart FX: fly animation + toast v2 */
(function () {
  'use strict';

  function q(sel) { return document.querySelector(sel); }
  function qa(sel) { return document.querySelectorAll(sel); }

  let _toastAutoTimer = null;
  let _dismissTimer = null;

  /* ── Update tabbar cart badge counts ── */
  function updateCartCount(count) {
    qa('[data-sm-cart-count]').forEach(el => {
      el.textContent = count > 0 ? count : '';
    });
  }

  /* ── Toast dismiss ── */
  function dismissToast(t) {
    if (_toastAutoTimer) { clearTimeout(_toastAutoTimer); _toastAutoTimer = null; }
    t.classList.remove('is-visible');
    _dismissTimer = setTimeout(() => {
      _dismissTimer = null;
      if (document.contains(t)) t.remove();
    }, 380);
  }

  /* ── Toast — speech bubble card with real tail div ── */
  function showToast(title, imgUrl, itemCount, price) {
    /* Remove any existing toast */
    const old = q('#sm-cart-toast');
    if (old) old.remove();
    if (_toastAutoTimer) { clearTimeout(_toastAutoTimer); _toastAutoTimer = null; }
    if (_dismissTimer) { clearTimeout(_dismissTimer); _dismissTimer = null; }

    const sub = [
      itemCount ? `${itemCount} item${itemCount > 1 ? 's' : ''}` : null,
      price || null
    ].filter(Boolean).join(' · ');

    const t = document.createElement('div');
    t.id = 'sm-cart-toast';
    /* Card first, then tail below it */
    t.innerHTML = `
      <div class="sm-ct-card">
        <div class="sm-ct-row">
          ${imgUrl ? `<img class="sm-ct-img" src="${imgUrl}" alt="" loading="lazy">` : '<div class="sm-ct-img"></div>'}
          <div class="sm-ct-text">
            <span class="sm-ct-label">${title || 'Added to cart!'}</span>
            ${sub ? `<span class="sm-ct-sub">${sub}</span>` : ''}
          </div>
          <a href="/cart" class="sm-ct-view-btn">View Cart →</a>
        </div>
        <div class="sm-ct-bar-wrap"><div class="sm-ct-bar-fill"></div></div>
      </div>
      <div class="sm-ct-tail"></div>`;
    document.body.appendChild(t);

    requestAnimationFrame(() => {
      t.classList.add('is-visible');
      const fill = t.querySelector('.sm-ct-bar-fill');
      if (fill) {
        requestAnimationFrame(() => {
          fill.style.transition = 'width 3.5s linear';
          fill.style.width = '0%';
        });
      }
    });

    _toastAutoTimer = setTimeout(() => {
      _toastAutoTimer = null;
      if (document.contains(t)) dismissToast(t);
    }, 3600);
  }

  /* ── Fly-to-cart orb ── */
  function flyToCart(sourceEl) {
    const cartIcon = q('.sm-tabbar [data-sm-cart-open] .sm-tabbar__icon');
    if (!sourceEl || !cartIcon) return;

    const srcR = sourceEl.getBoundingClientRect();
    const tgtR = cartIcon.getBoundingClientRect();
    const size = 40;
    const startX = srcR.left + srcR.width / 2 - size / 2;
    const startY = srcR.top + srcR.height / 2 - size / 2;

    const orb = document.createElement('div');
    orb.className = 'sm-cart-orb';
    orb.style.cssText = `left:${startX}px;top:${startY}px;width:${size}px;height:${size}px;background:var(--sm-ink,#0A0A0A);box-shadow:0 4px 16px rgba(0,0,0,0.25)`;

    const img = sourceEl.querySelector('img');
    if (img && img.src) {
      const i = document.createElement('img');
      i.src = img.src;
      i.style.cssText = 'width:100%;height:100%;object-fit:cover;';
      orb.appendChild(i);
    }
    document.body.appendChild(orb);

    requestAnimationFrame(() => {
      orb.style.transition = 'transform 0.65s cubic-bezier(0.2,0,0.8,1), opacity 0.65s, width 0.65s, height 0.65s';
      orb.style.transform = `translate(${tgtR.left + tgtR.width / 2 - size / 2 - startX}px,${tgtR.top + tgtR.height / 2 - size / 2 - startY}px)`;
      orb.style.width = '18px';
      orb.style.height = '18px';
      orb.style.opacity = '0';
    });
    setTimeout(() => orb.remove(), 750);
  }

  /* ── Move Buy it now to be a direct grid child so it can span full width ── */
  function initQtyAtcRow() {
    document.querySelectorAll('.sm-fp-qty-atc-row').forEach(function(row) {
      var payBtn = row.querySelector('.shopify-payment-button');
      if (payBtn && payBtn.parentElement !== row) {
        row.appendChild(payBtn);
      }
    });
  }

  /* ── Init — fetch cart count for tabbar badge ── */
  function init() {
    initQtyAtcRow();
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => updateCartCount(cart.item_count || 0))
      .catch(() => {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
